// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"8dd161e9","123":"8dd161e9"}[chunkId] + ".chunk.css";
};